module.exports = __webpack_public_path__ + "img/login.b85dd620.png";